import { Typography } from "@mui/material";
import GraphVisualization from "../../../../components/graph-visualization";
import type { Graph, Test } from "../../../../types";

interface GraphTabProps {
  test: Test | undefined;
  graphData: { graph: Graph } | undefined;
}

export function GraphTab({ test, graphData }: GraphTabProps) {
  if (!graphData || !test?.graph_path?.length) {
    return <Typography>No graph available for this test</Typography>;
  }

  return (
    <GraphVisualization
      nodes={graphData.graph.nodes}
      edges={graphData.graph.edges}
      path={test.graph_path}
    />
  );
}
